import config from '../../config/config.js';
import {SessionStorageConfiguration, ConfigurationBuilder} from './configuration-builder';
import {CLIENT_ERRORS, ErrorHandler, StarzPlayer} from 'starzplayer';

export class PlayerWrapper {

    constructor() {
        this._setLanguage();
        this._attachMoveAwayFromPage();
        this._validateBrowser();

        this.storedConfiguration = SessionStorageConfiguration.byStoredConfiguration();
        if (!this.storedConfiguration || window.location.href.indexOf(this.storedConfiguration.contentId) === -1) {
            this._validateDomain(document.referrer);
        }
    }

    play(configuration) {
        this._enableAnalytics(configuration);
        this._setLanguage(configuration.language);
        this._hideUri();
        this._addClientSpecificEventHandlers(configuration);
        new StarzPlayer(configuration);
    }

    /**
     * When the user moves away from the page, a message needs to be shown for show connection
     * @private
     */
    _attachMoveAwayFromPage() {
        if (!window) {
            ErrorHandler.throwError(CLIENT_ERRORS.UNSUPPORTED_BROWSER, {
                reason: 'Window needs to be available'
            });
            return false;
        }
        // If the user moves away from the page:
        // Page event handlers
        window.onbeforeunload = function (e) {
            console.log(CLIENT_ERRORS.REDIRECT);
            ErrorHandler.throwError(Object.assign(CLIENT_ERRORS.REDIRECT, {
                attachScreenTo: document.getElementsByTagName('body')[0],
                override: true
            }), {
                reason: 'Back button clicked'
            });
            return undefined;
        };

    }

    _addClientSpecificEventHandlers(starzplayerConfig) {
        if (starzplayerConfig.videoType === 'trailer') {
            starzplayerConfig['eventHandlers'] = starzplayerConfig['eventHandlers'] ? starzplayerConfig['eventHandlers'] : {};
            starzplayerConfig.eventHandlers['onPlaybackFinished'] = () => window.history.back();
        }
        return starzplayerConfig;
    };

    _hideUri() {
        history.replaceState(undefined, undefined, location.pathname);
        return true;
    };

    _setLanguage(language) {
        if(!language) {
            // Try to get the language from the url
            // FIXME Shouldn't this come from the configuration file?
            const allowedLanguages = ['en', 'fr', 'ar'];
            const pathSplit = document.location.pathname.split('/');
            language = pathSplit[1];

            language = allowedLanguages.indexOf(language) > -1 ? language : 'en'

        }
        document.getElementsByTagName('html')[0].lang = language;
        ErrorHandler.addOptions({
            language
        });
        return true;
    };

    _validatePath() {
        if (window.location.pathname && window.location.pathname.length > 4) {
            return true;
        }
        ErrorHandler.throwError(Object.assign(CLIENT_ERRORS.INVALID_URI, {
            redirect: {
                timeout: 10,
                location: config.contentUri
            }
        }), {
            reason: 'No path was specified for uri',
            uri: window.location.href
        });
    }

    _validateBrowser() {
        if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
            if (window.location.href.indexOf('?play') > -1) window.location = location.pathname;
            ErrorHandler.throwError(CLIENT_ERRORS.UNSUPPORTED_BROWSER, {
                reason: 'Internet explorer 10 is not supported.'
            });
        }
        return true;
    }

    _validateDomain(domain) {
        const ALLOWED_DOMAINS = config.allowedDomains;

        if (domain && domain !== '') {
            for (let i = 0; i < ALLOWED_DOMAINS.length; i++){
                if (domain.indexOf(ALLOWED_DOMAINS[i]) > -1){
                    return true;
                }
            }
        } else {
            if(window.location.href.indexOf('sp_r') > -1){
                return true;
            }
        }

        ErrorHandler.throwError(Object.assign(CLIENT_ERRORS.INVALID_DOMAIN, {
            redirect: {
                timeout: 5000,
                location: config.contentUri
            }
        }), {
            reason: `User is trying to play something from domain ${domain}, but this domain is not added to the configuration file. Allowed domains for this environment`,
            allowed_domains: ALLOWED_DOMAINS.join(','),
            uri: window.location.href
        });

        return false;
    }

    _hasConfigurationInCache() {
        SessionStorageConfiguration.byStoredConfiguration();
    }

    /**
     * Enables the google analytics
     * @param {Object} configuration
     * @param {String} configuration.feed
     * @private
     */
    _enableAnalytics(configuration) {
        if (!configuration) {
            console.error('Trying to initialize analytics without configurationObject. Analytics not initialized');
            return;
        }

        let globalUserId = /userId=(.[^&]*)/.exec(configuration.feed);
        globalUserId = globalUserId && globalUserId.length > 0 ? globalUserId[1] : undefined;

        (function (i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r;
            i[r] = i[r] || function () {
                    (i[r].q = i[r].q || []).push(arguments);
                }, i[r].l = 1 * new Date();
            a = s.createElement(o),
                m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
        })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

        ga('create', config.googleAnalyticsId, 'auto', {
            'userId': globalUserId
        });

        //Custom Dimensions
        ga('set', 'dimension1', globalUserId);
        ga('require', 'displayfeatures');
        ga('send', 'pageview');
    }

}



// WEBPACK FOOTER //
// ./src/assets/js/player-wrapper.js